import { Paper, Stack, styled } from '@ethings/ui-toolkit';
import { FC, type JSX } from 'react';
import { BottomNavigation } from '../../components';
import { MobileTabSelection } from './event-history.types';

interface Props {
  bottomActions: JSX.Element[];
  content: JSX.Element;
  value: MobileTabSelection;
}

const StyledPaper = styled(Paper)({
  zIndex: 1100,
});

const ScrollableStack = styled(Stack)({
  overflowY: 'auto',
  scrollbarWidth: 'none',
  '::-webkit-scrollbar': {
    display: 'none',
  },
});

export const EventHistoryMobile: FC<Props> = ({ bottomActions, content, value }) => {
  return (
    <Stack height="100%" width="100%">
      <ScrollableStack
        flexGrow={1}
      >
        {content}
      </ScrollableStack>
      <StyledPaper elevation={3}>
        <BottomNavigation<MobileTabSelection> value={value}>
          {bottomActions}
        </BottomNavigation>
      </StyledPaper>
    </Stack>
  );
};
